import {
  artworkRequired,
  hasLinkedServices,
  hasDocumentReferenceComplete,
  getStates,
} from '@printdeal/business-logic';
// @ts-expect-error
import { canRemoveFile } from '../../../../../../helpers/order/Order';
import { Environment } from '../../../../../../helpers/env';
import { SanitizedLineItem, SanitizedOrder } from '../../../../../../types/order/Order';

const ReasonsDisabled = {
  ARTWORK_ABSENT: 'Artwork invalid',
  ARTWORK_UNNECESSARY: 'The product does not require artwork',
  CANNOT_REMOVE_FILE: 'File cannot be removed due to lineItem state',
  HAS_ART_SERVICE: 'Has art service',
};

const canRemoveFilesHelper = (lineItem: SanitizedLineItem, order: SanitizedOrder) => {
  if (!artworkRequired(lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_UNNECESSARY,
    };
  }

  if (!hasDocumentReferenceComplete(lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_ABSENT,
    };
  }

  const states = getStates(Environment);
  if (!canRemoveFile(lineItem, states.lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.CANNOT_REMOVE_FILE,
    };
  }

  if (hasLinkedServices(lineItem.id, order)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.HAS_ART_SERVICE,
    };
  }

  return {
    enabled: true,
  };
};

export default canRemoveFilesHelper;
